/**
 * Firebase設定・初期化
 *
 * Firebase Authentication、Firestore、Hostingの設定を管理
 */

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Firebase設定
// 環境変数から取得（.envファイルで設定）
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// 設定値の確認
if (!firebaseConfig.apiKey) {
  console.error('[KnoVelo Firebase] 環境変数が設定されていません。.envファイルを確認してください。');
}

// Firebaseアプリを初期化
const app = initializeApp(firebaseConfig);

// Firestoreインスタンス
const db = getFirestore(app);

// Authインスタンス
const auth = getAuth(app);

// Cloud Functions URL (asia-northeast1リージョン)
const FUNCTIONS_BASE_URL = 'https://asia-northeast1-knovelo-e7e2c.cloudfunctions.net';

/**
 * Cloud Functionを呼び出すヘルパー関数
 */
async function callFunction(functionName, data) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('ログインが必要です');
  }

  // IDトークンを取得
  const idToken = await user.getIdToken();

  const response = await fetch(`${FUNCTIONS_BASE_URL}/${functionName}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`
    },
    body: JSON.stringify(data)
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.error || 'Cloud Function呼び出しエラー');
  }

  return { data: result };
}

/**
 * Stripe Checkout Sessionを作成
 */
async function createCheckoutSession(data) {
  return callFunction('createCheckoutSession', data);
}

/**
 * Stripe Portal Sessionを作成
 */
async function createPortalSession(data) {
  return callFunction('createPortalSession', data);
}

console.log('[KnoVelo Firebase] Firebaseを初期化しました');

export { app, db, auth, createCheckoutSession, createPortalSession };
